import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const operationalBasesRoutes = [
  {
    path: '/operational-bases',
    name: Routes.OperationalBases,
    component: () => import('@/pages/contexts/portal/operational-bases/Index.vue'),
    meta: {
      pageTitle: 'Manage Operational Bases',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_OPERATIONAL_BASES,
    },
    children: [
      {
        path: 'create-operational-base',
        name: Routes.OperationalBaseCreate,
        component: () => import('@/pages/contexts/portal/operational-bases/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_OPERATIONAL_BASES,
        },
      },
      {
        path: 'edit/:operationalBaseId',
        name: Routes.OperationalBaseEdit,
        component: () => import('@/pages/contexts/portal/operational-bases/Edit.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_OPERATIONAL_BASES,
        },
      },
      {
        path: 'edit/:operationalBaseId/create-experience-location',
        name: Routes.ExperienceLocationCreate,
        component: () => import('@/pages/contexts/portal/operational-bases/experience-locations/Create.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_OPERATIONAL_BASES,
        },
      },
      {
        path: 'edit/:operationalBaseId/edit-experience-location/:experienceLocationId',
        name: Routes.ExperienceLocationEdit,
        component: () => import('@/pages/contexts/portal/operational-bases/experience-locations/Edit.vue'),
        meta: {
          middleware: [
            Middleware.REQUIRES_AUTH,
            Middleware.TOGGLES_NAV_DRAWER,
          ],
          permission: AppPermissions.MANAGE_OPERATIONAL_BASES,
        },
      },
    ],
  },
]
